import { motion } from "framer-motion";
import { Award, CheckCircle2, ShieldCheck } from "lucide-react";
import { CLIENTS } from "@/lib/content";

const credentials = [
  { value: "LEVEL 1", label: "B-BBEE contributor", icon: Award },
  { value: "135%", label: "Procurement recognition", icon: ShieldCheck },
  { value: "100%", label: "Black female-owned", icon: CheckCircle2 },
];

export default function TrustWall() {
  return (
    <section data-testid="trust-wall" className="relative border-y border-white/[0.06] py-14">
      <div className="container-edx">
        <div className="trust-rail">
          <div className="trust-rail-lead">
            <span>EDX.02</span>
            <strong>Built in South Africa.<br />Ready for the world.</strong>
          </div>
          {credentials.map(({ value, label, icon: Icon }) => (
            <div className="trust-credential" key={label}>
              <Icon size={18} />
              <strong>{value}</strong>
              <span>{label}</span>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-5 md:flex-row md:items-center">
          <span className="shrink-0 text-[10px] uppercase tracking-[0.3em] text-edx-muted">
            Selected client network
          </span>
          <div className="h-px flex-1 bg-white/[0.08]" />
          <div className="grid flex-[3] grid-cols-2 gap-2 sm:grid-cols-4">
            {CLIENTS.map((client, index) => (
              <motion.div
                key={client.name}
                data-testid={`client-${index}`}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.06 }}
                className="client-chip"
              >
                <i className={`bg-gradient-to-br ${client.color}`}>{client.initials}</i>
                <span><strong>{client.name}</strong><small>{client.tagline}</small></span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
